import { SERVER_STATUS, CHECKING_SERVER, POLLING_TICK, POLLING_START, POLLING_STOP } from '../actions/index';

let initialState = {
  pollingOn: false,
  time: 0,
  serverUp: false,
  isFetching: false,
}

export default function(state = initialState, action) {
  switch(action.type) {
    case POLLING_START:
      return {
        ...state,
        pollingOn: true,
        time: 0, // Begin time at 0 everytime we start the timer
        offset: action.offset,
        interval: action.interval
      }
    case POLLING_STOP:
      return {
        ...initialState,
        time: state.time
      }
    case POLLING_TICK:
      return {
        ...state,
        time: state.time + (action.time - state.offset),
        offset: action.time
      }
    case CHECKING_SERVER:
      if (action.fetching) {
        return {
          ...state,
          isFetching: true
        }
      } else {
        return {
          ...state,
          isFetching: false
        }
      }
    case SERVER_STATUS:      
      if (action.data.status) {
        return {
          ...state,
          serverUp: true
        }
      } else {
        return {
          ...state,
          serverUp: false
        }
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_polling.js